module.exports = __webpack_public_path__ + "img/New York.0e69d5e4.png";